import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useMapURLParams } from "../../../../../hooks/map/useMapParams";
import { getItemWebStorage } from "../../../../../features/webStorageSaver";
import { getMatchedMapPageAdditionalLayerConfigs } from "../../../mapFeatures/layers";

export default function ConfiguredPageLayersLegend() {
    const currentConfig = getItemWebStorage('currentConfig');
    const location = useLocation();
    const { mapName, mapOption } = useMapURLParams();

    const legendItems = useMemo(() => {
        const matchedConfigs = getMatchedMapPageAdditionalLayerConfigs(currentConfig, {
            mapName,
            mapOption,
            pathname: location.pathname
        });

        return matchedConfigs.flatMap((pageConfig: any) => {
            const configuredLayers = Array.isArray(pageConfig?.layers) ? pageConfig.layers : [];
            return configuredLayers
                .filter((layer: any) => layer?.visibleByDefault !== false && layer?.legend?.label)
                .map((layer: any) => ({
                    key: layer?.legend?.id ?? layer?.layerName ?? layer?.legend?.label,
                    label: layer.legend.label,
                    color: layer.legend.color ?? "#D9534F"
                }));
        });
    }, [currentConfig, location.pathname, mapName, mapOption]);

    if (legendItems.length === 0) return null;

    return (
        <div className="map-overlay map-overlay-configured-page-layers-legend">
            <div className="configured-page-layers-legend-div">
                {legendItems.map((item: any) => (
                    <div key={item.key} className="configured-page-layer-legend-item">
                        <div className="configured-page-layer-legend-color" style={{ background: item.color }} />
                        <span className="configured-page-layer-legend-label">{item.label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
